import type { VisaEnrichmentEnvelope } from "@/lib/visa-enrichment-normalize"
import type { VisaSummary } from "@/types/visa-api"
import type { VisaManualOverride } from "@/types/visa-manual-override"

export function hasAnyManualOverride(ov: VisaManualOverride | null | undefined): boolean {
  if (!ov) return false
  return Object.keys(ov).length > 0
}

export function applyManualOverrideToEnvelope(
  ai: VisaEnrichmentEnvelope,
  ov: VisaManualOverride | null | undefined
): VisaEnrichmentEnvelope {
  if (!ov) return ai
  const merged: VisaEnrichmentEnvelope = { ...ai }

  if (ov.steps_override) merged.steps = ov.steps_override
  if (typeof ov.cost_override === "number" && Number.isFinite(ov.cost_override)) {
    merged.total_cost_usd = ov.cost_override
  }
  if (typeof ov.timeline_override === "string") {
    merged.total_estimated_days = ov.timeline_override
  }
  if (ov.tips_override) merged.success_tips = ov.tips_override
  if (ov.pitfalls_override) merged.common_pitfalls = ov.pitfalls_override

  return merged
}

/**
 * User-facing visa summary overrides.
 * - notes_override → VisaSummary.notes
 * - documents_override → VisaSummary.required_documents
 */
export function applyManualOverrideToVisaSummary(
  summary: VisaSummary,
  ov: VisaManualOverride | null | undefined
): VisaSummary {
  if (!ov) return summary
  const merged: VisaSummary = { ...summary }
  if (typeof ov.notes_override === "string") merged.notes = ov.notes_override
  if (ov.documents_override) merged.required_documents = ov.documents_override
  return merged
}

export function effectiveRequiredDocuments(
  base: string[] | null | undefined,
  ov: VisaManualOverride | null | undefined
): string[] {
  if (ov?.documents_override) return ov.documents_override
  return base ?? []
}

